import { BundleBase, syncItemFromSelect } from '@scale/bundle-base';
import { BundleUpdatedEvent } from '@scale/events';

class BundleAddons extends BundleBase {
  setupBundle() {
    this.on('change', this.#onChange.bind(this));
    this.on('click', this.#onButtonClick.bind(this));
  }

  getBundleType() { return 'addon'; }
  getBundleName() { return this.querySelector('.bundle-addons__title')?.textContent.trim() || 'Addons'; }

  getActiveItems() {
    return [...this.querySelectorAll('[data-addon-item][data-active="true"]')];
  }

  #onChange(event) {
    const checkbox = event.target.closest?.('[data-ref="addon-checkbox"]');
    if (checkbox) {
      const item = checkbox.closest('[data-addon-item]');
      if (item) item.dataset.active = String(checkbox.checked);
      this.broadcast(new BundleUpdatedEvent());
      return;
    }

    const select = event.target.closest?.('[data-ref="addon-variant-select"]');
    if (select) {
      syncItemFromSelect(select, 'data-addon-item', 'addon-price');
      this.broadcast(new BundleUpdatedEvent());
    }
  }

  #onButtonClick(event) {
    const btn = event.target.closest?.('[data-ref="addon-button"]');
    if (!btn) return;
    event.preventDefault();

    const item = btn.closest('[data-addon-item]');
    if (!item) return;

    item.dataset.active = item.dataset.active === 'true' ? 'false' : 'true';
    this.broadcast(new BundleUpdatedEvent());
  }
}

if (!customElements.get('scale-bundle-addons')) {
  customElements.define('scale-bundle-addons', BundleAddons);
}
